<script>
import {
    layoutComputed
} from "@/state/helpers";
import Horizontal from "./horizontal";

export default {
    components: {
        Horizontal,
    },
    data() {
        return {};
    },
    computed: {
        ...layoutComputed,
    },
    methods: {},
    mounted() {
         //let height = screen.height;
        // eslint-disable-next-line no-console
          // var ekranYukseklik = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
        // eslint-disable-next-line no-console
         //console.log( window.innerHeight,document.documentElement.clientHeight, document.body.clientHeight)
         //document.querySelector(".vgt-responsive").style.minHeight = document.body.clientHeight + 'px';
      
        // document.querySelector("html").setAttribute('dir', 'rtl');
    }
};
</script>

<template>
<div>
    <Horizontal v-if="layoutType === 'horizontal'" :layout="layoutType">
        <slot />
    </Horizontal>
</div>
</template>
